module.exports = __webpack_public_path__ + "static/media/user-hard-hat.47e780e2.svg";